import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';

//import {Area, AreaChart, Label, Legend, Tooltip, XAxis, YAxis, LineChart, Line, ReferenceLine} from "recharts";

import "./RiskStatAnalysisGraph.css"
import {dollarFormatWithCommas, roundTo2Decimals} from "../../../util";
const CustomTooltip = (props) => {
	//console.log("CustomTooltip");
	//console.log(props);
	const payloadItems = [];
	for (let payloadIndex in props.payload) {
		const payload = props.payload[payloadIndex];
		//console.log("payload");
		//console.log(payload);
		let value = parseFloat(payload.value)*parseInt(payload.payload.fullMark, 10);

		payloadItems.push(
			<li key={payload.name} className="recharts-tooltip-radar-item"
				style={{display: 'table-row', paddingTop: '4px', paddingBottom: '4px'}}>
				<span className="recharts-tooltip-radar-item-name" style={{display: 'table-cell', paddingLeft: '8px', color:payload.dataKey==="Industry"?payload.color:"white"}}>{payload.name}</span>
				<span className="recharts-tooltip-radar-item-separator" style={{display: 'table-cell', paddingLeft: '2px'}}> : </span>
				{payload.payload.axis && payload.payload.axis.split(" ")[0] === "Market"?
					<span
						className="recharts-tooltip-radar-item-value"
						 style={{display: 'table-cell', paddingLeft: '12px', textAlign:'right'}} >
						 	{ dollarFormatWithCommas(value) }
					</span>
					:
					<span
						className="recharts-tooltip-radar-item-value"
						 style={{display: 'table-cell', paddingLeft: '12px', textAlign:'left'}} >
						 	{ roundTo2Decimals(value) }
					</span>
				}
			</li>
		);
	}


	return (
		<div style={{
			margin: '0px',
			padding: '5px',
			//backgroundColor: '22aef0',
			color: '#c2c2c2',
			fontFamily: 'GothamLight',
			lineHeight: 1.2,
			border: '1px solid #83bed3'

		}}>
			<p 
			style={{fontSize: '18px', color: '#c2c2c2', fontWeight: 'bold'}}
			className={"recharts-tooltip-radar-label"}>{props.label ?(props.label.split(" ")[0] === "Market" ? props.label.split("-")[0]:props.label.split("-")[0] + " Events"):""}</p>
			<ul style={{padding: '0px', margin: '0px', color: 'white'}}>
				{payloadItems}
			</ul>
		</div>
	);
};

function renderPolarAngleAxis(props) {
	//console.log("axis");
	
	//console.log(props);
	//console.log(props.x);
	//console.log(props.y);
	//console.log(props.rest);
	let cx = 300;
	let cy = 150;
	//let cx = props.y - (props.payload.coordinate * Math.sin(props.payload.offset));
	//let cy = props.x - (props.payload.coordinate * Math.cos(props.payload.offset));
	let newY = props.y + (props.y - cy) / 5;
	let newX = props.x + (props.x - cx) / 5;
	//console.log(cx);
	//console.log(cy);
	let textArr = props.payload.value.split("-");
  return (
	<g >
	   
		<text
		  radius={props.radius}
		  stroke={"#FFFFFF"}
		  fill={"#FFFFFF"}
		  fontSize={12}
		  fontFamily={'GothamLight'}
		  verticalAnchor="top"
			y={newY}
			x={newX}
		  text-anchor={"middle"}
		  
		>
			<tspan textAnchor="top" x={newX} dy={"0em"}>{textArr[0]}</tspan>
			<tspan textAnchor="top" x={newX} dy="20">{textArr[1]}</tspan>
		  
		</text>
	</g>
  );
};

const RiskStatAnalysisComponent = (props) => (
	
	// <ResponsiveContainer width={1200} height={400}>
		<RadarChart cx="50%" cy="50%" outerRadius="80%" width={600} height={400} label={false} margin={{ top: 5, right: 5, bottom: 5, left: 5 }} data={props.graphData}>
			<PolarGrid />
			<PolarAngleAxis dataKey="axis" stroke="#FFFFFF" cx="730" cy="250" tick={props => renderPolarAngleAxis(props)}  />
			<PolarRadiusAxis tickCount="3" tick={false}  label={false} axisLine={false} />
			<Radar name={props.company} dataKey="Company" stroke="#673AB7" fill="#673AB7" fillOpacity={0.7} activeDot={{ stroke: "red", fill: "red" }} dot={true} tick={false} />
			<Radar name={props.industry} dataKey="Industry" stroke={props.sectorColor} fill={props.sectorColor} fillOpacity={0.4}  activeDot={{ stroke: props.sectorColor }} dot={true} tick={false} />
			<Legend verticalAlign="bottom" height={10} wrapperStyle={{ paddingTop: "20px" }} />
			<Tooltip
		        content={<CustomTooltip />}
		        position={{ x: -355, y: 200 }}
		        allowEscapeViewBox={true}
		      />
		</RadarChart>

	// </ResponsiveContainer>
);


export default RiskStatAnalysisComponent;



// WEBPACK FOOTER //
// ./src/common/components/RiskStatAnalysis/RiskStatAnalysisComponent.js